import { addPeriod, bucketStart, type Period } from '@/lib/readiness/series'
import type { Projection } from '@/lib/readiness/projection'

export type RangeKey = 'est' | '3' | '6' | '12' | 'all' | 'custom'
export type SeriesKey = 'score' | 'domain' | 'coverage'

export interface ChartControls {
  period: Period
  range: RangeKey
  series: SeriesKey
  custom: { from: string; to: string }
}

// `To est. L3` (the default): all history, then the projection to the end of
// its confidence range, with the submission milestone always inside.
export function projectionEnd(projection: Projection | null | undefined, milestone: string | null): Date | null {
  if (!projection) return null
  const ends = [projection.summary.p80, projection.summary.all_l3_by, milestone].filter((x): x is string => !!x).map((x) => new Date(x).getTime())
  return ends.length ? new Date(Math.max(...ends)) : null
}

export function rangeBounds(c: ChartControls, startedAt: string | null, now = new Date(), projectionTo: Date | null = null): { from: Date; to: Date } {
  if (c.range === 'custom' && c.custom.from && c.custom.to) return { from: new Date(c.custom.from), to: new Date(c.custom.to) }
  if (c.range === 'est') return { from: startedAt ? new Date(startedAt) : addPeriod(bucketStart(now, c.period), c.period, -5), to: projectionTo && projectionTo > now ? projectionTo : now }
  const to = now
  if (c.range === 'all') return { from: startedAt ? new Date(startedAt) : addPeriod(bucketStart(now, c.period), c.period, -5), to }
  const n = Number(c.range)
  return { from: addPeriod(bucketStart(now, c.period), c.period, -(n - 1)), to }
}
